import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UserContextService } from "./user-context.service";
import { map } from "rxjs";

export const AdminGuardService: CanActivateFn = () => {
  const userContextSvc = inject(UserContextService);
  const router = inject(Router);
  return userContextSvc.getUserContext().pipe(
    map((user) => {
      const isAdmin = user?.GlobalAdmin;
      if (isAdmin) {
        return true;
      }
      router.navigate(["/welcome"]);
      return false;
    })
  );
};
